<main class="container-fluid">
  <h2 class="title-courses">Hola {{infoUser.attributes.field_name}}, ¿Qué quisieras aprender hoy?</h2>
  <section>
    <app-course-card></app-course-card>
  </section>
</main>
